import './ResetPassword.scss';
import React, { useState, useEffect, useRef } from 'react';
import * as yup from 'yup';
import { Formik, Form } from 'formik';
import { Button, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

import appapi from '../../../api/apiClient';
import { showmessage } from '../../../utils/toastr';
import { buttonStyle1 } from '../../../utils/commonStyle';
import { colors } from '../../../utils/colors';
import { setLoading } from '../../../redux/features/appSlice';
import { useDispatch } from 'react-redux';
import backArrow from '../../../assets/images/backArrow.svg';
import FormTextField from '../../../components/FormTextField';
import Logo from '../../../assets/images/ze-logo.svg';

/**
 * Validation Schema for register
 */
const validationSchema = yup.object({
  email: yup
    .string('Enter your Email')
    .matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Email is Invalid')
    .required('Email is Required'),
});

export default function ResetPassword() {
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1000px)');
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { email } = state;

  const formRef = useRef();

  const theme = useTheme();

  const [hasFocused, setHasFocused] = useState(false);

  const [data, setData] = useState({
    email: '',
  });

  useEffect(() => {
    if (email) {
      setData({ email: email });
      setHasFocused(true);
    } else {
      setHasFocused(false);
    }
  }, [email]);

  const [formSubmitted, SetFormSubmitted] = useState(false);
  const [resend, SetResend] = useState(false);

  /**
   *
   * @param {email} obj
   * This submit is for reseting password
   */

  const resetPassword = async (obj, resend = false) => {
    dispatch(setLoading(true));
    let email = obj.email;
    let payload = {
      email: obj?.email ? obj.email : data.email,
    };
    const response = await appapi.post(`auth/forgetPassword`, payload);
    if (response.ok) {
      const data = response.data;
      dispatch(setLoading(false));
      if (data.status === '7400') {

        SetFormSubmitted(true);
      } else {
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      // showmessage(`Something Went Wrong!`, 2000, 'error')
    }
  };

  /**
   *
   * @returns Redirect to initial page which is login
   */

  const onClickLoginRoute = () => navigate(`/login`);
  const onClickOtpRoute = (id, email) =>
    navigate(`/otp/${id}/${email}`, {
      state: { email: data.email, otpId: id },
    });

  //emailForm
  const form = () => {
    return (
      <>
        <Typography
          className="fw-bold ff-Roboto createHeading"
          color={theme.palette.primary.main}
        >
          {' '}
          Reset Password{' '}
        </Typography>
        <Typography
          className="fs-12 ff-Roboto fw-regular"
          color={theme.palette.text.primary.main}
        >
          Enter your registered email id to receive your password reset instructions.
        </Typography>
        <Formik
          innerRef={formRef}
          enableReinitialize={true}
          initialValues={{
            email: data?.email || '',
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => resetPassword(values)}
        >
          {({ handleSubmit, values, handleChange, errors, touched, handleBlur, isValid, dirty }) => (
            <Form
              style={{ minHeight: '484px' }}
              noValidate
              autoComplete="off"
            >
              <Stack
                flex={1}
                className="mt-9"
                sx={{ mb: '14px' }}
              >
                <FormTextField
                  label="Email"
                  name="email"
                  sx={{ mb: 0 }}
                  lowerCase={true}
                  hasFocused={hasFocused}
                  setHasFocused={(val) => setHasFocused(val)}
                />
              </Stack>
              <Button
                sx={{
                  ...buttonStyle1,
                  marginBottom: '0',
                  width: '100%',
                  mt: '2.3px',
                  backgroundColor: theme.palette.primary.light,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                  },
                  color: theme.palette.background.main,
                }}
                disabled={!hasFocused ? !(dirty && isValid) : !isValid || !hasFocused}
                type="submit"
              >
                SEND
              </Button>
              <Stack
                direction="row"
                className="mt-16"
                justifyContent="center"
                onClick={onClickLoginRoute}
              >
                <img
                  src={backArrow}
                  alt="Not found"
                  className="arrow"

                />
                <Typography
                  className="ff-Roboto fw-regular fs-12"
                  color={theme.palette.grey.main}
                  style={{ cursor: 'pointer' }}
                >
                  Go back to{' '}
                </Typography>

                <Typography
                  // onClick={onClickLoginRoute}
                  className="ff-Roboto fw-bold fs-12"
                  color={theme.palette.primaryDark.light}
                  style={{ marginLeft: '7px', cursor: 'pointer' }}
                >
                  Login
                </Typography>
              </Stack>
            </Form>
          )}
        </Formik>
      </>
    );
  };

  const formSubmittedContent = () => {
    return (
      <>
        <Typography
          className="fw-bold ff-Roboto createHeading !mb-3"
          color={theme.palette.primary.light}
        >
          {' '}
          Successful!{' '}
        </Typography>
        <Typography
          className="fs-12 ff-Roboto fw-regular "
          color={colors.blackMain}
        >
          Your request has been submitted successfully. Please check your email for further instructions.
        </Typography>
        {/* {resend ? (
          ''
        ) : (
          <Stack
            direction="row"
            style={{ marginTop: '7px' }}
            spacing={0.5}
          >
            <Typography
              className="ff-Roboto fw-regular fs-12"
              color={colors.gray}
            >
              Click here to
            </Typography>
            <Typography
              onClick={() => resetPassword({}, true)}
              className="ff-Roboto fw-bold fs-12"
              color={colors.primaryDark}
              style={{ cursor: 'pointer' }}
            >
              Resend
            </Typography>
            <Typography
              className="ff-Roboto fw-regular fs-12"
              color={colors.gray}
            >
              mail
            </Typography>
          </Stack>
        )} */}
        <Button
          sx={{
            ...buttonStyle1,
            marginBottom: '0',
            marginTop: '31px',
            textTransform: 'capitalize',
            width: '100%',
            backgroundColor: theme.palette.primary.light,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
            color: theme.palette.background.main,
          }}
          onClick={onClickLoginRoute}
        >
          Go Back To Login
        </Button>
      </>
    );
  };

  return (
    <div
      className="resetContainer"
      style={{
        padding: isMobile ? '16px' : '0',
        minHeight: isMobile ? 'auto' : '100vh',
      }}
    >
      
        <Stack
          style={{ maxWidth: '1368px', margin: 'auto' }}
          direction="row"
          justifyContent="space-between"
        >
          <Stack
            className="leftStack"
            style={{ width: '100%' }}
          >
            <Stack className="formSubmittedStyle mt-28">
              <Stack direction="row" justifyContent={'center'}>
                {/* <Typography
                  color={theme.palette.primary.light}
                  className="fw-bold ff-Roboto"
                  style={{ fontSize: '54px' }}
                >
                  Carbon
                </Typography>
                <Typography
                  color={theme.palette.secondary.main}
                  className="fw-bold ff-Roboto"
                  style={{ fontSize: '54px', marginLeft: '10px' }}
                >
                  Wallet
                </Typography> */}
                <img src={Logo} className='w-[240px]' />
              </Stack>
              <div
                style={{
                  marginTop: formSubmitted ? '7.5vh' : '5vh',
                }}
              >
                {formSubmitted ? <>{formSubmittedContent()}</> : <>{form()}</>}
              </div>
            </Stack>
          </Stack>
        </Stack>
    </div>
  );
}
